module.exports = __webpack_public_path__ + "img/27.684f9be0.jpg";